const ME_INITIALIZING = 'ME_INITIALIZING'
const ME_INITIALIZING_SUCCESS = 'ME_INITIALIZING_SUCCESS'
const ME_INITIALIZING_ERROR = 'ME_INITIALIZING_ERROR'
const ME_SET_DISTRICTS = 'ME_SET_DISTRICTS'
const ME_SET_SCHOOLS = 'ME_SET_SCHOOLS'
const ME_SET_EDUCATORS = 'ME_SET_EDUCATORS'
const ME_SET_CLASSES = 'ME_SET_CLASSES'
const ME_SET_STUDENTS = 'ME_SET_STUDENTS'
const ME_SELECT = 'ME_SELECT'
const ME_SET_FILTER = 'ME_SET_FILTER'
const ME_UPDATE_SCHOOL = 'ME_UPDATE_SCHOOL'
const ME_DELETING_RECORD = 'ME_DELETING_RECORD'
const ME_DELETING_RECORD_SUCCESS = 'ME_DELETING_RECORD_SUCCESS'
const ME_DELETING_RECORD_ERROR = 'ME_DELETING_RECORD_ERROR'

export function deletingRecord() {
  return {
    type: ME_DELETING_RECORD,
  }
}

export function deletingRecordSuccess() {
  return {
    type: ME_DELETING_RECORD_SUCCESS,
  }
}

export function deletingRecordError(error) {
  return {
    type: ME_DELETING_RECORD_ERROR,
    error,
  }
}

export function updateSchool(schoolId, key, value) {
  return {
    type: ME_UPDATE_SCHOOL,
    schoolId,
    key,
    value,
  }
}

export function setFilter(filterName, filterText) {
  return {
    type: ME_SET_FILTER,
    filterName,
    filterText,
  }
}

export function select(dataType, id) {
  return {
    type: ME_SELECT,
    dataType,
    id,
  }
}

export function setDistricts(districts) {
  return {
    type: ME_SET_DISTRICTS,
    districts,
  }
}

export function setSchools(schools) {
  return {
    type: ME_SET_SCHOOLS,
    schools,
  }
}

export function setEducators(educators) {
  localStorage.setItem('educators',JSON.stringify(educators)) 
  return {
    type: ME_SET_EDUCATORS,
    educators,
  }
}

export function setClasses(classes) {
  return {
    type: ME_SET_CLASSES,
    classes,
  }
}

export function setStudents(students) {
  localStorage.setItem('students',JSON.stringify(students)) 
  return {
    type: ME_SET_STUDENTS,
    students,
  }
}

export function initializing () {
  return {
    type: ME_INITIALIZING
  }
}

export function initializingSuccess() {
  return {
    type: ME_INITIALIZING_SUCCESS,
  }
}

export function initializingError(error) {
  return {
    type: ME_INITIALIZING_ERROR,
    error,
  }
}


const students = JSON.parse(localStorage.getItem('students'))
const educators = JSON.parse(localStorage.getItem('educators'))

const initialState = {
  isInitializing: false,
  isInitializingError: '',
  districts: null,
  schools: null,
  educators: (localStorage.getItem('educators')) ? educators:null,
  classes: null,
  students:  (localStorage.getItem('students')) ? students:null,
  selection: {
    district: '',
    school: '',
    teacher: '',
    class: '',
  },
  filters: {
    districtState: '',
  },
  isDeleting: false,
  isDeletingError: '',
  error: '',
}

export function manageEducators (state = initialState, action) {
  switch (action.type) {
    case ME_DELETING_RECORD :
      return {
        ...state,
        isDeleting: true,
      }
    case ME_DELETING_RECORD_SUCCESS :
      return {
        ...state,
        isDeleting: false,
      }
    case ME_DELETING_RECORD_ERROR :
      return {
        ...state,
        isDeleting: false,
        isDeletingError: action.error
      }
    case ME_UPDATE_SCHOOL :
      return {
        ...state,
        schools: {
          ...state.schools,
          [action.schoolId] : {
            ...state.schools[action.schoolId],
            [action.key]: action.value
          }
        }
      }  
    case ME_SET_FILTER :
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filterName]: action.filterText,
        }
      }
    case ME_SELECT : 
      return {
        ...state,
        selection: {
          ...state.selection,
          [action.dataType]: action.id,
        }
      }
    case ME_SET_DISTRICTS :
      return {
        ...state,
        districts: action.districts,
      }
    case ME_SET_SCHOOLS :
      return {
        ...state,
        schools: action.schools,
      }
    case ME_SET_EDUCATORS :
      return {
        ...state,
        educators: action.educators,
      }
    case ME_SET_CLASSES :
      return {
        ...state,
        classes: action.classes,
      }
    case ME_SET_STUDENTS :
      return {
        ...state,
        students: action.students,
      }
    case ME_INITIALIZING :
      return {
        ...state,
        isInitializing: true,
      }
    case ME_INITIALIZING_SUCCESS :
      return {
        ...state,
        isInitializing: false,
      }
    case ME_INITIALIZING_ERROR : 
      return {
        ...state,
        isInitializing: false,
        error: action.error,
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/manageEducators.js